import { useContext, useEffect, useState, useTransition } from "react";

import { NO_VALUE_DISPLAY } from "@ryde/shared";

import { DropdownSourceContext } from "../../contexts";

export const usePassengerTypeTitle = (passengerTypeId: number | undefined) => {
  const { getDropdownLabel } = useContext(DropdownSourceContext);
  const [passengerTypeTitle, setPassengerTypeTitle] = useState("");
  const [, startTransition] = useTransition();

  useEffect(() => {
    const fetchPassengerTypeTitle = async (): Promise<void> => {
      if (!passengerTypeId) {
        setPassengerTypeTitle(NO_VALUE_DISPLAY);
      }

      const areaTitleFetched = await getDropdownLabel(
        "passengerType",
        passengerTypeId,
      );
      setPassengerTypeTitle(areaTitleFetched || NO_VALUE_DISPLAY);
    };

    startTransition(() => {
      fetchPassengerTypeTitle();
    });
  }, [passengerTypeId, getDropdownLabel]);

  return passengerTypeTitle;
};
